import { Component, OnInit } from '@angular/core';
import { Utilities } from '../../../helpers/utilities';
import { BaseServiceService } from '../../../services/base-service.service'
import { GeneralFormComponent } from '../../controls/general-form/general-form.component';
import { HelperImages } from 'src/app/helpers/helper-images';
import { HelperRules } from 'src/app/helpers/helper-rules';
import { HelperActions } from 'src/app/helpers/helper-actions';
import { Guid } from "guid-typescript";
import { StaticData } from 'src/app/helpers/static-data';
import { FormGroup } from "@angular/forms";
import { event } from 'jquery';
import { Enumerable, List } from "../../../../assets/linqts/compilado/index";

@Component({
  selector: 'app-rzona-empresa',
  templateUrl: './rzona-empresa.component.html',
  styleUrls: ['./rzona-empresa.component.css']
})
export class RZonaEmpresaComponent extends GeneralFormComponent implements OnInit {

  isSearch: boolean = null;
  filtroGeneral = "";
  GridViewAdjutosZona: any;
  EsPais: any;
  EsDepartamento: any;
  EsCiudad: any;
  EsSeccional: any;
  IdPais: any;
  IdDepartamento: any;
  IdCiudad: any;
  IdSeccional: any;

  constructor(
    public baseService: BaseServiceService,
    public utility: Utilities,
    public helperImages: HelperImages,
    public helperRules: HelperRules,
    public helperActions: HelperActions) {
    super(baseService, utility, helperImages, helperRules, helperActions);
  }

  public OnInitEnd() {
    this.GridViewAdjutosZona = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "GridViewAdjutosZona" });
    this.EsPais = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "EsPais" });
    this.EsDepartamento = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "EsDepartamento" });
    this.EsCiudad = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "EsCiudad" });
    this.EsSeccional = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "EsSeccional" });
    this.IdPais = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "IdPais" });
    this.IdDepartamento = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "IdDepartamento" });
    this.IdCiudad = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "IdCiudad" });
    this.IdSeccional = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "IdSeccional" });
    
    this.preSaveEmitter.subscribe(modelo => {
      this.modelo.modelo.AdjuntosZonaEmpresa = JSON.stringify(this.modelo.modeloVirtual.GridViewAdjutosZona);
    });

    if (this.parentClearCall) {
      this.parentClearCall.subscribe((event) => {
        if (event && event.resetModel) {
          if (this.configs && this.configs.ConfigIdPais && this.configs.ConfigIdPais.Context) {
            this.configs.ConfigIdPais.Context.ResetComboBox([], true);
          }
          if (this.configs && this.configs.ConfigIdDepartamento && this.configs.ConfigIdDepartamento.Context) {
            this.configs.ConfigIdDepartamento.Context.ResetComboBox([], true);
          }
          if (this.configs && this.configs.ConfigIdCiudad && this.configs.ConfigIdCiudad.Context) {
            this.configs.ConfigIdCiudad.Context.ResetComboBox([], true);
          }
          if (this.configs && this.configs.ConfigSeccionales && this.configs.ConfigSeccionales.Context) {
            this.configs.ConfigSeccionales.Context.ResetComboBox([], true);
          }
          this.SetModelToControls();
        }
      });
    }

    super.OnInitEnd();
  }

  public OnActionEventHandler(event) {
    switch (event.ControlType) {
      case 'CommandButton':
        super.OnActionEventHandler(event);
        if (event.Option.Type == "Edit") {
          if (this.modelo.modeloVirtual["GridViewAdjutosZona"] && this.modelo.modeloVirtual["GridViewAdjutosZona"].length > 0) {
            this.modelo.modeloVirtual.AdjuntosZona = 'ok';
            this.SetModelToControls();
          }
        }
        break;
      case 'Button':
        super.OnActionEventHandler(event);
        break;
      default:
        super.OnActionEventHandler(event);
        break;
    }
    
    if (event.actionType == "EliminarItem") {
      [this.configs.ConfigIdPais, this.configs.ConfigIdDepartamento, this.configs.ConfigIdCiudad, this.configs.ConfigSeccionales]
        .forEach(conf => this.FiltrarItemsDelCombo(conf));

      if (this.modelo.modeloVirtual["GridViewAdjutosZona"].length < 1) {
        this.modelo.modeloVirtual.AdjuntosZona = null;
        this.SetModelToControls();
      }
    }
  }

  public OnSelectedComboBox(item: any, controlName: string, config: any) {
    try {
      super.OnSelectedComboBox(item, controlName, config);

      if (!item) return;

      var TypeZona = this.modelo.modelo.EsPais ? "Pais" :
                     this.modelo.modelo.EsDepartamento ? "Departamento" :
                     this.modelo.modelo.EsCiudad ? "Ciudad" :
                     this.modelo.modelo.EsSeccional ? "Seccional" : "";

      if (!this.modelo.modeloVirtual["GridViewAdjutosZona"]) {
        this.modelo.modeloVirtual["GridViewAdjutosZona"] = [];
      }

      let idItem = item.IdPais || item.IdDepartamento || item.IdCiudad || item.IdSedeEmpresa;

      let debeAgregar = (this.modelo.modelo.EsPais && controlName == "IdPais") ||
                        (this.modelo.modelo.EsDepartamento && controlName == "IdDepartamento") ||
                        (this.modelo.modelo.EsCiudad && controlName == "IdCiudad") ||
                        (this.modelo.modelo.EsSeccional && controlName == "Seccionales");

      if (debeAgregar) {
        if (this.modelo.modeloVirtual["GridViewAdjutosZona"].some(x => x.Id === idItem && x.Tipo === TypeZona)) {
          this.utility.VerModalWarning({ "titulo": "Ítem duplicado", "descripcion": "Esta zona ya está en la lista." });
          return;
        }

        this.modelo.modeloVirtual["GridViewAdjutosZona"].push({ Id: idItem, Nombre: item.Nombre, Tipo: TypeZona });

        this.FiltrarItemsDelCombo(config);

        if (this.modelo.modeloVirtual["GridViewAdjutosZona"].length >= 1) {
          this.modelo.modeloVirtual.AdjuntosZona = 'ok';
          this.SetModelToControls();
        }
      }
    } catch (error) {
      this.utility.logger.LogError(error, null, { componentName: this.componentName, method: "OnSelectedComboBox" });
    }
  }

  public OnDataTableEditHandler(event) {
    if (event.data.data.findItem.AdjuntosZonaEmpresa != "" && event.data.data.findItem.AdjuntosZonaEmpresa != "[]") {
      this.modelo.modelo.AdjuntosZonaEmpresa = event.data.data.findItem.AdjuntosZonaEmpresa;
      this.modelo.modeloVirtual.GridViewAdjutosZona = JSON.parse(this.modelo.modelo.AdjuntosZonaEmpresa);

      setTimeout(() => {
        [this.configs.ConfigIdPais, this.configs.ConfigIdDepartamento, this.configs.ConfigIdCiudad, this.configs.ConfigSeccionales]
          .forEach(conf => this.FiltrarItemsDelCombo(conf));
      }, 800);
    }
    this.SetModelToControls();
  }

  private FiltrarItemsDelCombo(config: any) {
    if (config && config.Context && config.Context.items) {
      if (!config.Context.itemsRespaldo || config.Context.itemsRespaldo.length === 0) {
        config.Context.itemsRespaldo = [...config.Context.items];
      }

      const seleccionados = this.modelo.modeloVirtual["GridViewAdjutosZona"] || [];
      config.Context.items = config.Context.itemsRespaldo.filter(iCombo => {
        let idCombo = iCombo.IdPais || iCombo.IdDepartamento || iCombo.IdCiudad || iCombo.IdSedeEmpresa;
        return !seleccionados.some(s => s.Id === idCombo);
      });
    }
  }
}